import { render } from "./AppTransition.vue?vue&type=template&id=2e6c8c22"
import script from "./AppTransition.vue?vue&type=script&lang=js"
export * from "./AppTransition.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__